// import React from "react";
import React, { useState } from "react";
import '../HomePage/Quotes.css';
import '../HomePage/HomeInsurance.css';
import PlansDetailbtn from "./PlansDetailbtn";
import BuyNowBtn from "./BuyNowBtn";
import Addonsbtn from "./Addonsbtn";
import DownloadBrochure from "./DownloadBrochure";
import AddonsPOP from "./AddonsPOP";
import CrossIcon from '../Images/Cross-icon.svg';
import { convertIntoLakh, CommaSeprator } from "./UtilityComponents/UilityFunctions";
const PlansFound = ({ PlanName, Premium, LogoURL, pdfURL, buyNow, propertyType, BuildingComponent, Addons, onAddonsSubmit }) => {
    const [compare, setCompare] = useState('');
    const [ShowAddonsPOP, setShowAddonspop] = useState(false);
    const compareChangeHandler = (event) => {
        setCompare(event.target.value);
    }
    return (
        <>
            <div className="Plans_Found">
                <div className="Plans_Found1">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="Plans">
                                <h6>{PlanName}</h6>
                            </div>
                        </div>
                    </div>
                    <div className="Plans2">
                        <div>
                            <div className="go-digit">
                                <img src={LogoURL} alt="Go digit" />
                            </div>
                            <div className="sum_insured1">
                              {/*  {Addons && <Addonsbtn Addons={Addons} setShowAddons={() => setShowAddonspop(!ShowAddonsPOP)} />}*/}
                            </div>
                        </div>
                        <div className="">
                            <div className="sum_insured2">
                                {(propertyType === "BUILDING" || propertyType === "Both") && < div >
                                    <small>Value of Building</small>
                                    <p>₹{convertIntoLakh(BuildingComponent.valueOfBuilding)}</p>
                                </div>}
                                {(propertyType === "HOUSEHOLD" || propertyType === "Both") && < div >
                                    <small>Household Items Sum Insured</small>
                                    <p>₹{convertIntoLakh(BuildingComponent.valueOfHouseHoldItem)}</p>
                                </div>}
                            </div>
                        </div>
                        <div className="">
                            <div className="BuyNow_BTN">
                                <BuyNowBtn netPremium={Premium} BuyNow={buyNow} />
                                <small className="d-block text-center">₹{CommaSeprator(Math.round(parseInt(Premium) / 12))} /month</small>
                            </div>
                        </div>
                    </div>
                    <div className="sum_insured1">
                        <p className="mb-0">No Manual claim process for amount less than <b>₹1 lakh</b></p>
                    </div>
                </div>
                <div className="plan_detail">
                    <div className="row">
                        <div className="compare">
                           {/* <div className="compare1">
                                <input type="checkbox" className="compareChecked" value={compare} onChange={compareChangeHandler} />
                                <label htmlFor="" className="mx-1">Compare</label>
                            </div>*/}
                            {/*<div className="plans_btn plans_btn11">
                                <PlansDetailbtn />
                            </div>*/}
                            <div>
                                <DownloadBrochure url={pdfURL} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {ShowAddonsPOP &&
                <div className="addons_pop">
                    <div className="col-lg-4 m-auto">
                        <div className="Form_popup">
                            <div className="cross_btn">
                                <button className="" onClick={() => setShowAddonspop(false)}>
                                    <img src={CrossIcon} alt="Home Insurance" />
                                </button>
                            </div>
                            <AddonsPOP Addons={Addons} onAddonsSubmit={data => {
                                setShowAddonspop(false);
                                onAddonsSubmit(data);
                            }} BtnValue="Update"
                            />
                        </div>
                    </div>
                </div>
            }
        </>
    );
}
export default PlansFound;